import { createFileRoute } from "@tanstack/react-router";
import { EligibilityScreen } from "@modules/appels/views";

export const Route = createFileRoute(
  "/_staff-area/cohorts/$cohortId/appels/$appelId/eligibility"
)({
  staticData: { title: "nav.cohorts" },
  component: EligibilityScreen,
});
